// Lightweight singleton-style fetch of public app config (Kirit's WhatsApp etc.).
// Cached in-memory after first call.
import { api } from "@/lib/api";

let _config = null;
let _inflight = null;

export const getConfig = async () => {
  if (_config) return _config;
  if (_inflight) return _inflight;
  _inflight = api.get("/config").then((r) => {
    _config = r.data || {};
    return _config;
  }).catch(() => {
    _config = { kirit_whatsapp: "919510317986", welcome_credits: 500 };
    return _config;
  }).finally(() => { _inflight = null; });
  return _inflight;
};

/** Normalize a phone to WhatsApp's required format: country code + number,
 * digits only (no +, no spaces). Bare 10-digit Indian mobiles get 91 prefixed. */
export const normalizeWaPhone = (raw) => {
  let n = (raw || "").replace(/\D/g, "");
  if (n.length === 11 && n.startsWith("0")) n = n.slice(1);   // drop leading 0
  if (n.length === 10) n = "91" + n;                          // add India country code
  return n;
};

/** Build a wa.me URL with prefilled message. Defaults to Kirit if no number given. */
export const buildWhatsappLink = (message, phone) => {
  const num = normalizeWaPhone(phone || _config?.kirit_whatsapp || "919510317986");
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${num}?text=${text}`;
};

/** TWA-safe WhatsApp opener. window.open is unreliable inside the Android
 * Trusted Web Activity wrapper, so we trigger a real anchor click (target
 * _blank) and fall back to a same-tab navigation. Never use fetch/iframe. */
export const openWhatsApp = (url) => {
  if (!url) return;
  try {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (_) {
    window.location.href = url;
  }
};

/** Title-case a name like "kirit bhandari" → "Kirit Bhandari". */
export const titleCase = (s) => {
  if (!s || typeof s !== "string") return s || "";
  return s.trim().toLowerCase().replace(/(^|\s|-|')(\p{L})/gu, (_, sep, ch) => sep + ch.toUpperCase());
};
